@tailwind base;
@tailwind components;
@tailwind utilities;

/* The default inline host has no definite width, so `max-w-full` on the trigger
 * below would have nothing to resolve against and the button would keep its
 * fit-content width, holding the whole bar row open. Block + min-width:0 makes
 * the host shrinkable and gives its descendants a width to measure against. */
:host {
  display: block;
  min-width: 0;
}
